/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Recovery_BodyInputs */

const en_features_recovery_body = /** @type {(inputs: Features_Recovery_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery is worked out from your sets, muscle by muscle. Your plan picks what is ready and leaves the rest for tomorrow.`)
};

const pl_features_recovery_body = /** @type {(inputs: Features_Recovery_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeneracja liczy się z Twoich serii, partia po partii. Plan wybiera to, co jest gotowe, a resztę zostawia na jutro.`)
};

/**
* | output |
* | --- |
* | "Recovery is worked out from your sets, muscle by muscle. Your plan picks what is ready and leaves the rest for tomorrow." |
*
* @param {Features_Recovery_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_recovery_body = /** @type {((inputs?: Features_Recovery_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Recovery_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_recovery_body(inputs)
	return en_features_recovery_body(inputs)
});